import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { FormElement, FormId } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { Url } from "../../../../router/enums";
import { selectCountry } from "../../../../store/HOC/genericUI.selectors";
import { subtractFieldsFromObject } from "../../../../utilities/functions";
import { selectApplicantData, selectUIData } from "../applicant.selectors";
import { copyApplicantToDriver, setUIObjectField } from "../applicant.slice";

import { ComponentId } from "./enums";

const useCopyApplicantToDriver = (): ((arg: string) => void) => {
  const dispatch = useDispatch();
  const { getValues, errors } = useFormContext();
  const countryValidator = useSelector(
    selectCountry(selectUIData)("applicantphone")
  );

  return (isDriver: string) => {
    const payload = {
      [ComponentId.APPLICANT_IS_DRIVER]: isDriver,
      countryValidator,
      ...(isDriver === "true" &&
        subtractFieldsFromObject(getValues(), errors, [
          FormId.APPLICANT,
          [
            ComponentId.APPLICANT_NAME,
            ComponentId.APPLICANT_SURNAME,
            ComponentId.APPLICANT_EMAIL,
            ComponentId.APPLICANT_PHONE,
          ],
        ])),
    };

    dispatch(copyApplicantToDriver(payload));
  };
};

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.APPLICANT,
  selector: selectApplicantData,
  redirect: Url.AC_INCIDENT,
  content: [
    {
      title: "Dane zgłaszającego",
      sections: [
        {
          id: "applicant-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_NAME,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_SURNAME,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: "applicant-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              id: ComponentId.APPLICANT_PHONE,
              country: selectCountry(selectUIData)("applicantphone"),
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_EMAIL,
              label: "Email",
              required: true,
            },
          ],
        },
        {
          id: "applicant-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.APPLICANT_IS_DRIVER,
              onChange: useCopyApplicantToDriver,
              required: true,
              label: "Czy osoba zgłaszająca kierowała pojazdem?",
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
